// @flow
import jwt_decode from 'jwt-decode';

import { LOCAL_STORAGE_KEYS } from '../constants/enums';
import { Context as SessionContext } from './SessionContext';
import { Consumer as SessionConsumer } from './SessionContext';
import SessionProvider, { clearStoredSession } from './SessionProvider';

export const getToken = () => localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
export const decodeToken = () => {
  const token = localStorage.getItem(LOCAL_STORAGE_KEYS.TOKEN);
  if (!token) return null;

  const decoded = jwt_decode(token);
  return decoded;
};

export { SessionContext, SessionConsumer, SessionProvider, clearStoredSession };
